import React from 'react';
import { Paper, Tab, Tabs } from '@mui/material';

type Props = { value: string; onChange: (value: string) => void };

class SimulationTabs extends React.PureComponent<Props> {
  render() {
    return (
      <Paper elevation={1}>
        <Tabs value={this.props.value} onChange={(_, value) => this.props.onChange(value)} variant="scrollable" scrollButtons="auto">
          <Tab value="executive" label="Executive Overview" />
          <Tab value="assumptions" label="Assumptions" />
          <Tab value="mixer" label="Interactive Simulation" />
          <Tab value="financials" label="Financial Analysis" />
          <Tab value="objectives" label="Objective Impact" />
          <Tab value="sensitivity" label="Sensitivity Analysis" />
          <Tab value="publish" label="Publish Determinant Budget" />
        </Tabs>
      </Paper>
    );
  }
}
export default SimulationTabs;
